const filter = {
  origins: [
    {
      name: "국내산",
      value: "국내산",
    },
    {
      name: "수입산",
      value: "수입산",
    },
    {
      name: "전체",
      value: "",
    },
  ],
  resistPrintings: [
    {
      name: "방염",
      value: "방염",
    },
    {
      name: "비방염",
      value: "비방염",
    },
    {
      name: "전체",
      value: "",
    },
  ],
  prices: [
    {
      name: "3만원 이하",
      value: ["0", "30000"],
    },
    {
      name: "3 ~ 10만원 이하",
      value: ["30000", "100000"],
    },
    {
      name: "10 ~ 20만원 이하",
      value: ["100000", "200000"],
    },
    {
      name: "20 ~ 100만원 이하",
      value: ["200000", "1000000"],
    },
    {
      name: "100만원 이상",
      value: ["1000000", "999999999"],
    },
    {
      name: "직접 입력",
      value: ["", ""],
    },
  ],
};

export default filter;
